import CreateUserPanel from '@frontend/components/user-access/CreateUserPanel';

export interface EcosystemIdentityPanelProps {
  expanded: boolean;
  onToggle: () => void;
  ecosystemId?: string;
}

/** Create/invite scoped to the focused ecosystem (pre-checked member group). */
export default function EcosystemIdentityPanel({
  expanded,
  onToggle,
  ecosystemId = '',
}: EcosystemIdentityPanelProps) {
  return (
    <CreateUserPanel
      expanded={expanded}
      onToggle={onToggle}
      ecosystemAttachMode={ecosystemId ? 'scoped' : 'optional'}
      scopedEcosystemId={ecosystemId}
    />
  );
}
